__turbopack_context__.v({
  "header": "calendarHeader-module-scss-module__hlw9CG__header",
  "navButton": "calendarHeader-module-scss-module__hlw9CG__navButton",
  "navIcon": "calendarHeader-module-scss-module__hlw9CG__navIcon",
  "nextButton": "calendarHeader-module-scss-module__hlw9CG__nextButton",
  "prevButton": "calendarHeader-module-scss-module__hlw9CG__prevButton",
  "section": "calendarHeader-module-scss-module__hlw9CG__section",
  "titleButton": "calendarHeader-module-scss-module__hlw9CG__titleButton",
  "titleButtonActive": "calendarHeader-module-scss-module__hlw9CG__titleButtonActive",
  "titleChevron": "calendarHeader-module-scss-module__hlw9CG__titleChevron",
  "titleChevronFlipDown": "calendarHeader-module-scss-module__hlw9CG__titleChevronFlipDown",
});
